import { Controller } from "@hotwired/stimulus"
import { interpolate } from "../lib/interpolate"

// Keeps a button disabled for a number of seconds and shows the time left in
// its label. The server renders the button disabled with the seconds left, so
// the count does not depend on the device clock.
//
//   data-countdown-button-seconds-value="45"
//   data-countdown-button-template-value="resend in %{time}"
export default class extends Controller {
  static values = { seconds: Number, template: String }

  connect() {
    this.label = this.element.textContent.trim()
    this.endsAt = Date.now() + this.secondsValue * 1000
    this.tick()
    if (this.remaining() > 0) this.timer = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  tick() {
    const remaining = this.remaining()

    if (remaining > 0) {
      this.element.disabled = true
      this.element.textContent = interpolate(this.templateValue, { time: this.format(remaining) })
    } else {
      clearInterval(this.timer)
      this.element.disabled = false
      this.element.textContent = this.label
    }
  }

  remaining() {
    return Math.max(0, Math.ceil((this.endsAt - Date.now()) / 1000))
  }

  format(seconds) {
    const minutes = Math.floor(seconds / 60)
    return `${minutes}:${String(seconds % 60).padStart(2, "0")}`
  }
}
